<template>
  <a-date-picker
    :value="momentVal"
    :disabled-date="disabledDate"
    @change="changeHandler"
  />
</template>
<script>
import { computed, toRefs } from 'vue'
import { useStore } from 'vuex'
import dayjs from 'dayjs'
import moment from 'moment'
export default {
  props: {
    selectedWeek: {
      type: Object,
      default: () => dayjs().day(5)
    }
  },
  emits: ['update:selectedWeek'],
  setup (props, { emit }) {
    const { selectedWeek } = toRefs(props)

    function changeHandler (val, str) {
      emit('update:selectedWeek', dayjs(str))
    }

    const store = useStore()
    const year = computed(() =>
      Number(
        (store.state.yearCycles[store.state.activeYearIndex] || [])[0]
          ?.displayName || dayjs().year()
      )
    )

    const momentVal = computed(() => moment(selectedWeek.value.format('YYYY-MM-DD'), 'YYYY-MM-DD'))

    const theLastDayOfSelectedYear = computed(() => dayjs().year(year.value).endOf('year'))
    const theStartDayOfSelectedYear = computed(() => dayjs().year(year.value).startOf('year'))

    const disabledDate = (currentDate) => {
      return currentDate.day() !== 5 || theStartDayOfSelectedYear.value.isAfter(currentDate) || theLastDayOfSelectedYear.value.isBefore(currentDate)
    }

    return {
      disabledDate,
      changeHandler,
      momentVal
    }
  }
}
</script>
<style lang="less" scoped>
</style>
